// extracted by mini-css-extract-plugin
module.exports = {"panel":"Panel_panel__1nQxb","panelOnlyBorder":"Panel_panelOnlyBorder__pccxd","panelGlowing":"Panel_panelGlowing__Pj0jn","panelTopFocus":"Panel_panelTopFocus__S4VQe"};